import { Button } from '@mui/material';
import React from 'react'

const ButtonPick = ({ text, onClick, addStyle, ...props }) => {
    const buttonStyles = {
        display: 'block',
        p: '0.75rem 1rem',
        lineHeight: '1.5rem',
        borderRadius: '8px',
        fontSize: '1rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '600',
        textTransform: 'captalize',
        backgroundColor: '#FF9F0D',
        '&:hover': {
            backgroundColor: '#e68a00'
        },
    }
    return (
        <Button
            variant="contained"
            sx={{ ...buttonStyles, ...addStyle }}
            fullWidth
            onClick={onClick}
            {...props}
        >
            {text}
        </Button >
    )
}

export default ButtonPick
